import { createAsyncThunk } from '@reduxjs/toolkit';
import API from '@Services/apiAxios';
import { BulkShipmentHistoryQuery } from './Type';
import { createSlice } from '@reduxjs/toolkit';

interface ShipmentExportState {
  isLoading: boolean;
  error: string | null;
  fileUrl: string | null;
}

const initialState: ShipmentExportState = {
  isLoading: false,
  error: null,
  fileUrl: null,
};

export const BulkOrderSummaryOrder = createAsyncThunk(
  'BatchSummaryReport',
  async (queryParams: BulkShipmentHistoryQuery) => {
    const res = await API.get(`/shipment/export/bulk?`, {
      params: queryParams,
    });
    return res.data;
  },
);

const shipmentExportSlice = createSlice({
  name: 'batchSummaryReport',
  initialState,
  reducers: {
    clearBulkOrderSummaryExportData: state => {
      state.fileUrl = null;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(BulkOrderSummaryOrder.pending, state => {
        state.isLoading = true;
        state.error = null;
        state.fileUrl = null;
      })
      .addCase(BulkOrderSummaryOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.fileUrl = action.payload?.data || null;
      })
      .addCase(BulkOrderSummaryOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearBulkOrderSummaryExportData } = shipmentExportSlice.actions;
export default shipmentExportSlice.reducer;
